/* Built In Imports */
import { Box, Flex, HStack, Text } from '@chakra-ui/react';

/* External Imports */
import { render } from 'datocms-structured-text-to-html-string';

/* Services */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import useDateTimeCount from '@ieo/hooks/useDateTimeCount';
import { Fragment } from 'react';

/**
 *
 * @param {*} currentDate
 * @returns
 */
export default function DayTimeCounter({
  currentDate,
  endDate,
  sectionContent,
  isMobile,
  ...props
}) {
  const { timeLeft, offerExtendedDate } = useDateTimeCount(
    currentDate,
    endDate
  );
  // console.log('{ timeLeft, offerExtendedDate }', {
  //   timeLeft,
  //   offerExtendedDate,
  // });

  const greyBannerText5 = sectionContent?.find(
    e => e.fieldId === 'grey-banner-text5'
  );
  const greyBannerText6 = sectionContent?.find(
    e => e.fieldId === 'grey-banner-text6'
  );
  const greyBannerText7 = sectionContent?.find(
    e => e.fieldId === 'grey-banner-text7'
  );
  const greyBannerText8 = sectionContent?.find(
    e => e.fieldId === 'grey-banner-text8'
  );
  // const offerEndText = sectionContent?.find(
  //   e => e.fieldId === 'offer-end-text'
  // );
  const offerExtendedText = sectionContent?.find(
    e => e.fieldId === 'offer-extended-text'
  );

  // Function to clean up the rendered text
  let cleanText = text =>
    render(text)?.replace(/<p>/g, '').replace(/<\/p>/g, '');

  return (
    <>
      {isMobile && timeLeft ? (
        <Box
          as="span"
          display={'flex'}
          alignItems="center"
          color="#C07513"
          textAlign="center"
          fontFamily="FedraSansStd-medium"
          fontSize={{ md: '16px', lg: '24px' }}
          mt="0"
          {...props}
        >
          {timeLeft.type === 'timer' ? (
            <Box as="span" display="flex" fontFamily="FedraSansStd-medium">
              <HStack sx={{ flexWrap: 'wrap' }}>
                <Text>{cleanText(greyBannerText5?.body)}</Text>
                <Text p="0" m="0"></Text>
              </HStack>
              <HStack sx={{ flexWrap: 'wrap' }}>
                <Text>
                  {timeLeft.days} {cleanText(greyBannerText6?.body)}:
                </Text>
                <Text p="0" m="0"></Text>
              </HStack>
              <HStack sx={{ flexWrap: 'wrap' }}>
                <Text>
                  {timeLeft.hours} {cleanText(greyBannerText7?.body)} :
                </Text>
                <Text p="0" m="0"></Text>
              </HStack>
              <HStack sx={{ flexWrap: 'wrap' }}>
                <Text>
                  {timeLeft.minutes} {cleanText(greyBannerText8?.body)}{' '}
                </Text>
                <Text p="0" m="0"></Text>
              </HStack>
            </Box>
          ) : (
            <>
              <Text>{timeLeft.days}</Text>
              <Text ms="5px">{cleanText(greyBannerText6?.body)}</Text>
            </>
          )}
        </Box>
      ) : (
        <Flex
          // ml="14px"
          fontSize={{
            base: '16px',
            md: '22px',
            lg: '26px',
            xl: '28px',
            '2xl': '32px',
          }}
          color={props.color ? props.color : '#CD3C4C'}
          fontFamily="FedraSansStd-medium"
          lineHeight="1.2"
        >
          {timeLeft ? (
            <Fragment>
              {timeLeft.type === 'timer' ? (
                <Box as="span" display="flex" fontFamily="FedraSansStd-medium">
                  <HStack>
                    <Text>{cleanText(greyBannerText5?.body)}</Text>
                    <Text p="0" m="0"></Text>
                  </HStack>
                  <HStack>
                    <Text>{timeLeft.days} Days :</Text>
                    <Text p="0" m="0"></Text>
                  </HStack>
                  <HStack>
                    <Text>
                      {timeLeft.hours} {cleanText(greyBannerText7?.body)} :
                    </Text>
                    <Text p="0" m="0"></Text>
                  </HStack>
                  <HStack ml={{ base: '-5px', md: '5px' }}>
                    <Text>
                      {timeLeft.minutes} {cleanText(greyBannerText8?.body)}{' '}
                    </Text>
                    <Text p="0" m="0"></Text>
                  </HStack>
                  {/* <HStack ml={{ base: '-5px', md: '5px' }}>
                    <Box display="inline" minW={{ base: '18px', lg: '50px' }}>
                      {timeLeft.seconds}S
                    </Box>
                  </HStack> */}
                </Box>
              ) : (
                <>
                  {offerExtendedDate ? (
                    <StructuredTextParser
                      pl="5px"
                      color="#CD3C4C"
                      textAlign="center"
                      fontFamily="FedraSansStd-medium"
                      fontSize={{ md: '16px', lg: '24px' }}
                      mt="0"
                      str={render(offerExtendedText?.body)} // end offer text
                    />
                  ) : (
                    <Box as="span" display={'flex'} alignItems="center">
                      {/* <StructuredTextParser
                        color="#CD3C4C"
                        textAlign="center"
                        fontFamily="FedraSansStd-medium"
                        fontSize={{ md: '16px', lg: '24px' }}
                        mt="0"
                        str={render(greyBannerText5?.body)}
                      /> */}
                      <Text
                        ml="5px"
                        color={props.color ? props.color : '#CD3C4C'}
                        textAlign="center"
                        fontFamily="FedraSansStd-medium"
                        fontSize={{ md: '26px', lg: '30px' }}
                      >
                        {timeLeft.days}
                      </Text>

                      <StructuredTextParser
                        pl="5px"
                        color={props.color ? props.color : '#CD3C4C'}
                        textAlign="start"
                        fontFamily="FedraSansStd-medium"
                        fontSize={{ md: '26px', lg: '30px' }}
                        mt="0"
                        str={render(greyBannerText6?.body)}
                      />
                    </Box>
                  )}
                </>
              )}
            </Fragment>
          ) : (
            <Box as="span" fontFamily="FedraSansStd-medium">
              {/* <StructuredTextParser
                color="#C07513"
                textAlign="center"
                fontFamily="FedraSansStd-medium"
                fontSize={{ md: '16px', lg: '24px' }}
                mt="0"
                str={render(offerEndText?.body)}
              /> */}
              <Text> </Text>
            </Box>
          )}
        </Flex>
      )}
    </>
  );
}
